import React, { useEffect, useState } from 'react';
import styles from './Dashboard.module.scss';

//redux
import { connect } from 'react-redux';
import { getVisibleClients } from '../../redux/clients/actions';

import TotalSales from './totalSales/TotalSales';
import Appointments from './appointments/Appointments';
import DealStatus from './dealStatus/DealStatus';
import UnitSoldTable from './unitSoldTable/UnitSoldTable';
import SiteView from './siteView/SiteView';
import { setClientDocumentStatus } from '../../api/Documents/setClientDocumentStatus';
// import { getAllSalesAgents } from '../../api/Dashboard/getSalesAgent.api';
import { makeStyles } from '@material-ui/core/styles';
import {
	Grid,
	Divider,
	Box,
	Button,
	Menu,
	MenuItem,
	Card,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { getSalesAgents } from '../../redux/salesAgent/actions';
import { getPurchasers } from '../../redux/purchasers/actions';
import { checkRolesAccessibilities } from '../../utils/checkRolesAccessibilities';
import { ZendeskAPI } from 'react-zendesk';

const useStyles = makeStyles((theme) => ({
	gridOuter: {
		marginBottom: 50,
		flexDirection: 'row',
		alignItems: 'self-start',
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column-reverse',
		},
	},
	gridLeft: {
		[theme.breakpoints.up('md')]: {
			flexDirection: 'row-reverse',
		},
	},
}));

const Dashboard = ({
	user,
	getVisibleClients,
	profileData,
	loading,
	allAgents,
	getSalesAgents,
	getPurchasers,
	rolesAccessibilities,
}) => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const [agentEl, setAgentEl] = useState(null);
	const [filterByDate, setFilterByDate] = useState('All');
	const [filterBySalesAgent, setFilterBySalesAgent] =
		useState('All sales agents');
	// const [salesAgents, setSalesAgents] = useState([]);
	const [salesAgentId, setSalesAgentId] = useState('allSalesAgents');

	useEffect(() => {
		//getPurchasers();
		getSalesAgents();
		// getAllSalesAgents((returned) => setSalesAgents(returned));
		getVisibleClients();
		document.documentElement.scrollTop = 0;
	}, []);

	useEffect(() => {
		if (user.uid) {
			setClientDocumentStatus(user.uid);
		}
	}, [user]);

	// Date menu
	const handleCloseDateMenu = () => {
		setAnchorEl(null);
	};

	const handleOpenDateMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClickDateMenu = (event) => {
		setFilterByDate(event.target.innerText.trim());
		handleCloseDateMenu();
	};

	//agent menu
	const handleCloseAgentMenu = () => {
		setAgentEl(null);
	};

	const handleOpenAgentMenu = (event) => {
		setAgentEl(event.currentTarget);
	};

	const handleAgentChange = (event) => {
		setFilterBySalesAgent(event.target.innerText.trim());
		setSalesAgentId(event.target.attributes.value.value);
		handleCloseAgentMenu();
	};

	return (
		<div className={styles.dashboard_page}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6} md={8} lg={9}>
					<div className={styles.header_text}>
						<p className={styles.title}>Dashboard</p>
						<p className={styles.subtitle}>
							Welcome back {profileData.fullName}!
						</p>
					</div>
				</Grid>
				<Grid
					className={styles.headerWrapper}
					item
					xs={9}
					sm={4}
					md={3}
					lg={2}
				>
					{checkRolesAccessibilities(
						rolesAccessibilities,
						user.userType,
						'dashboard',
						'dashboard',
						0
					) && (
						<>
							<Button
								fullWidth={true}
								variant='outlined'
								endIcon={<ArrowDropDownIcon />}
								className={styles.agent_dropdown}
								onClick={handleOpenAgentMenu}
							>
								{filterBySalesAgent}
							</Button>
							<Menu
								anchorEl={agentEl}
								onClose={handleCloseAgentMenu}
								open={Boolean(agentEl)}
							>
								<MenuItem
									value='allSalesAgents'
									className={styles.menuItem}
									onClick={handleAgentChange}
								>
									All sales agents
								</MenuItem>
								{allAgents?.length > 0 &&
									allAgents.map((salesAgent) => (
										<MenuItem
											className={styles.menuItem}
											key={salesAgent.salesAgentID}
											value={salesAgent.salesAgentID}
											onClick={handleAgentChange}
										>
											{salesAgent.salesAgentName}
										</MenuItem>
									))}
							</Menu>
						</>
					)}
				</Grid>
				<Grid
					className={styles.headerWrapper}
					item
					xs={3}
					sm={2}
					md={1}
					lg={1}
				>
					{checkRolesAccessibilities(
						rolesAccessibilities,
						user.userType,
						'dashboard',
						'dashboard',
						1
					) && (
						<>
							<Button
								fullWidth={true}
								variant='outlined'
								endIcon={<ArrowDropDownIcon />}
								className={styles.date_dropdown}
								onClick={handleOpenDateMenu}
								style={{ textTransform: 'none' }}
							>
								{filterByDate}
							</Button>
							<Menu
								anchorEl={anchorEl}
								onClose={handleCloseDateMenu}
								open={Boolean(anchorEl)}
							>
								<MenuItem
									className={styles.menuItem}
									onClick={handleClickDateMenu}
								>
									Today
								</MenuItem>
								<MenuItem
									className={styles.menuItem}
									onClick={handleClickDateMenu}
								>
									Week
								</MenuItem>
								<MenuItem
									className={styles.menuItem}
									onClick={handleClickDateMenu}
								>
									Month
								</MenuItem>
								<MenuItem
									className={styles.menuItem}
									onClick={handleClickDateMenu}
								>
									All
								</MenuItem>
							</Menu>
						</>
					)}
				</Grid>
			</Grid>
			<Divider className={styles.my_lg} />
			<Grid container className={classes.gridOuter} spacing={1}>
				<Grid item container sm={12} md={9}>
					<Grid item xs={12}>
						<Box m={1}>
							{loading === false ? (
								<>
									{user.userType === 'superadmin' ? (
										<TotalSales
											salesAgentId={salesAgentId}
											filterByDate={filterByDate}
										/>
									) : (
										<TotalSales
											salesAgentId={user.uid}
											filterByDate={filterByDate}
										/>
									)}
								</>
							) : (
								<Card
									variant='outlined'
									className={styles.cardLoader}
								></Card>
							)}
						</Box>
					</Grid>
					<Grid
						item
						container
						className={classes.gridLeft}
						spacing={2}
					>
						<Grid item xs={12} sm={12} md={8}>
							<Box m={1} style={{ height: '100%' }}>
								{loading === false ? (
									<>
										{user.userType === 'superadmin' ? (
											<UnitSoldTable
												salesAgentId={salesAgentId}
												filterByDate={filterByDate}
											/>
										) : (
											<UnitSoldTable
												salesAgentId={user.uid}
												filterByDate={filterByDate}
											/>
										)}
									</>
								) : (
									<Card
										variant='outlined'
										className={styles.cardLoader}
									></Card>
								)}
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={4}>
							<Box m={1} style={{ height: '100%' }}>
								{loading === false ? (
									<>
										{user.userType === 'superadmin' ? (
											<SiteView
												salesAgentId={salesAgentId}
												filterByDate={filterByDate}
											/>
										) : (
											<SiteView
												salesAgentId={user.uid}
												filterByDate={filterByDate}
											/>
										)}
									</>
								) : (
									<Card
										variant='outlined'
										className={styles.cardLoader}
									></Card>
								)}
							</Box>
						</Grid>
					</Grid>
				</Grid>
				<Grid item container sm={12} md={3}>
					<Grid item xs={12} sm={6} md={12}>
						<Box m={1}>
							{loading === false ? (
								<div>
									{user.userType === 'superadmin' ? (
										<Appointments
											salesAgentId={salesAgentId}
											filterByDate={filterByDate}
										/>
									) : (
										<Appointments
											filterByDate={filterByDate}
										/>
									)}
								</div>
							) : (
								<Card
									variant='outlined'
									className={styles.cardLoader}
								></Card>
							)}
						</Box>
					</Grid>
					<Grid item xs={12} sm={6} md={12}>
						<Box m={1}>
							{loading === false ? (
								<>
									<div>
										{user.userType === 'superadmin' ? (
											<DealStatus
												salesAgentId={salesAgentId}
												filterByDate={filterByDate}
											/>
										) : (
											<DealStatus
												salesAgentId={user.uid}
												filterByDate={filterByDate}
											/>
										)}
									</div>
								</>
							) : (
								<Card
									variant='outlined'
									className={styles.cardLoader}
								></Card>
							)}
						</Box>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
	profileData: state.profile.profileInfo,
	loading: state.clients.loading,
	// loading: true,
	allAgents: state.salesAgent.allAgents,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	getVisibleClients,
	getSalesAgents,
	getPurchasers,
})(Dashboard);
